(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
document.getElementById("openFlowworld").addEventListener("click", function(){
  document.getElementById("flowworldPopup").classList.add("active");
});
document.getElementById("closeFlowworld").addEventListener("click", function(){
  document.getElementById("flowworldPopup").classList.remove("active");
});

const container = document.querySelector('.flowworld-popup');

let isDragging = false;
let startX, startY;
let scrollLeft, scrollTop;

container.addEventListener('mousedown', (e) => {
  isDragging = true;
  startX = e.pageX;
  startY = e.pageY;
  scrollLeft = container.scrollLeft;
  scrollTop = container.scrollTop;
});

container.addEventListener('mouseleave', () => {
  isDragging = false;
});

container.addEventListener('mouseup', () => {
  isDragging = false;
});

container.addEventListener('mousemove', (e) => {
  if (!isDragging) return;
  e.preventDefault();
  const walkX = e.pageX - startX;
  const walkY = e.pageY - startY;
  container.scrollLeft = scrollLeft - walkX;
  container.scrollTop = scrollTop - walkY;
});

// Enable horizontal scroll with mouse wheel
container.addEventListener('wheel', (e) => {
  if (!e.shiftKey) {
    container.scrollLeft += e.deltaY;
    e.preventDefault();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
